// Shared category helpers. The UNCAT sentinel and the "is this uncategorised?"
// check were repeated 15+ times across routes and lib modules; this is the one
// home for them, plus the income/expense category-type sets.

// UNCAT is generated from internal/domain (Go) — re-exported here so the many
// `import { UNCAT } from '$lib/category'` sites stay unchanged.
import { UNCAT } from './db/generated';
export { UNCAT };

/** True when a transaction/split has no real category (absent or the UNCAT sentinel). */
export function isUncategorised(category: string | null | undefined): boolean {
	return !category || category === UNCAT;
}

/** A transaction's category, defaulting an absent value to the UNCAT sentinel. */
export function categoryOrUncat(category: string | null | undefined): string {
	return category || UNCAT;
}

/** Human label for a category name (UNCAT renders as "Uncategorised"). */
export function displayCategoryName(name: string): string {
	return name === UNCAT ? 'Uncategorised' : name;
}

/** Category types that represent income vs. expenses (used for type-aware UI). */
export const INCOME_TYPES = new Set(['Income']);
export const EXPENSE_TYPES = new Set([
	'Mandatory Costs',
	'Non-Essential Spending',
	'Saving',
	'Spending'
]);
